export default "__VITE_ASSET__B8gzP17t__"